import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'y42-context-menu-duplicate',
  templateUrl: './context-menu-duplicate.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContextMenuDuplicateComponent {
  @Output()
  duplicateClick = new EventEmitter();
}
